import PropTypes from "prop-types";
import { Controller, useFormContext } from "react-hook-form";

import { Grid, Paper, Typography } from "@mui/material";

import { SellerBankAccountSelect } from "@/features/seller-bank-accounts";
import { CustomDatePicker, CustomInputField } from "@/features/ui";

export const EditableFieldsSection = ({ sellerId }) => {
  const {
    register,
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <Paper sx={{ p  : 3, borderRadius: 2 }}>
      <Grid container spacing={3}>
        <Grid size={{ xs: 12 }}>
          <Typography variant="subtitle1">Detail Faktur Pembelian</Typography>
        </Grid>
        <Grid size={{ xs: 12, md: 4 }}>
          <Controller
            name="transactionDate"
            control={control}
            render={({ field, fieldState }) => (
              <CustomDatePicker
                value={field.value}
                onChange={field.onChange}
                required
                label="Tanggal Transaksi"
                error={fieldState.invalid}
                helperText={fieldState.error?.message}
                InputProps={{
                  disableFuture: true,
                }}
              />
            )}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 4 }}>
          <Controller
            name="sellerBankAccount"
            control={control}
            render={({ field, fieldState }) => (
              <SellerBankAccountSelect
                // The sales side always sells from an outlet, so the seller of
                // an incoming invoice is the hub itself.
                sellerableId={sellerId}
                sellerableType="OUTLET"
                value={field.value}
                onChange={field.onChange}
                disabled={!sellerId}
                TextFieldProps={{
                  required: true,
                  label: "Rekening Bank Pemasok",
                  placeholder: "Pilih Rekening",
                  error: fieldState.invalid,
                  helperText: fieldState.error?.message,
                }}
              />
            )}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 4 }}>
          <CustomInputField
            name="note"
            label="Catatan"
            register={register}
            error={!!errors.note}
            helperText={errors.note?.message}
          />
        </Grid>
      </Grid>
    </Paper>
  );
};

EditableFieldsSection.propTypes = {
  sellerId: PropTypes.string,
};
